import { BoxProps, Image, Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { IoCheckmarkCircle, IoWarning } from 'react-icons/io5';

type LoadingProps = BoxProps & {
  isLoading: boolean;
  isError?: boolean;
};

export const Loading = ({
  isLoading,
  isError,
  ...props
}: LoadingProps) => {
  const { t } = useTranslation(['common', 'pages/dashboard']);

  return (
    <Box pt={20} {...props}>
      {isLoading && (
        <Box m="auto" display="flex">
            <Box
              position="relative"
              w="240px"
              margin="0 auto 100px"
              display="block"
            >
              <Image
                position="absolute"
                left={{
                  base: "-16px",
                  sm: "0",
                  lg: "0"
                }}
                top="-50px"
                width="91px"
                src="/images/pages/hover-item.png"
                alt=""
                animation="hover"
              />
              <Text
                textAlign="center"
                fontWeight="900"
                fontSize="20px"
                letterSpacing="0.05em"
                pl={20}
                color="brand.staticWhite"
              >
                Loading...
              </Text>
            </Box>
            <Box
              display="block"
              w="100%"
            >
              <Text
                textAlign="center"
                color="brand.staticWhite"
                fontSize="20px"
                fontWeight="600"
              >
                {t('pages/dashboard:components.loading.text')}
              </Text>
            </Box>
          </Box>
      )}
      {!isLoading && (
        <>
          {isError ? (
            <IoWarning size="3rem" color="red" />
          ) : (
            <IoCheckmarkCircle size="3rem" color="green" />
          )}
        </>
      )}
    </Box>
  );
};
